import { render, staticRenderFns } from "./DeliverableTemplateDashboard.vue?vue&type=template&id=006e4ef2&"
import script from "./DeliverableTemplateDashboard.vue?vue&type=script&lang=js&"
export * from "./DeliverableTemplateDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('006e4ef2')) {
      api.createRecord('006e4ef2', component.options)
    } else {
      api.reload('006e4ef2', component.options)
    }
    module.hot.accept("./DeliverableTemplateDashboard.vue?vue&type=template&id=006e4ef2&", function () {
      api.rerender('006e4ef2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/views/DeliverableTemplateDashboard.vue"
export default component.exports